import { toApiDiscount, toDiscount } from '@/api/mappers/mapDiscount';
import { toApiStatus, toStatus } from '@/api/mappers/mapStatus';
import {
  Promotion as ApiPromotion,
  PromotionListResponse as ApiPromotionListResponse,
  PromotionCreateRequest,
  PromotionUpdateRequest,
} from '@/gen/api';
import {
  PromotionCreate,
  Promotion as PromotionModel,
  Promotions,
  PromotionUpdate,
} from '@/models/Promotion';

export const toPromotion = (apiPromotion: ApiPromotion): PromotionModel => {
  return {
    ...apiPromotion,
    discounts: apiPromotion.discounts.map(toDiscount),
    status: apiPromotion.status ? toStatus(apiPromotion.status) : 'UNKNOWN',
  };
};

export function toPromotions(response: ApiPromotionListResponse): Promotions {
  return {
    items: response.items.map(toPromotion),
    totalCount: response.totalCount,
    estimatedTotalCount: response.estimatedTotalCount,
  };
}

export const toCreatePromotionRequest = (promotion: PromotionCreate): PromotionCreateRequest => ({
  ...promotion,
  discounts: promotion.discounts.map(toApiDiscount),
  status: toApiStatus(promotion.status),
});

export const toUpdatePromotionRequest = (promotion: PromotionUpdate): PromotionUpdateRequest => ({
  ...promotion,
  discounts: promotion.discounts.map(toApiDiscount),
  status: toApiStatus(promotion.status),
});
